module.exports = __webpack_public_path__ + "static/img/icon_empty.cce6df4b.png";